import LwcModal from "../../../components/LwcModal";
import PropTypes from "prop-types";

const SaveProfileModal = ({ handleClose, handleModalSubmit, show }) => (
	<LwcModal
		cancelButton={false}
		handleClose={handleClose}
		handleModalSubmit={handleModalSubmit}
		show={show}
		submitButtonText="Close"
		title="My Account"
	>
		<p className="text-center fw-bold fs-18 my-5">
			Your updates have been saved.
		</p>
	</LwcModal>
);

SaveProfileModal.propTypes = {
	handleClose: PropTypes.func.isRequired,
	handleModalSubmit: PropTypes.func.isRequired,
	show: PropTypes.bool.isRequired
};

export default SaveProfileModal;
